import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/app/guides/measuring-arched-windows/page.tsx");
